export default __webpack_public_path__ + "static/media/car3.e7300f90.jpeg";